export const EMPLOYEES_GET_SEND = 'EMPLOYEES_GET_SEND';
export const EMPLOYEES_GET_RECIEVED = 'EMPLOYEES_GET_RECIEVED';
export const EMPLOYEES_GET_ERROR = 'EMPLOYEES_GET_ERROR';
export const EMPLOYEES_GET_BY_IDS_ERROR = 'EMPLOYEES_GET_BY_IDS_ERROR';
